import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaFlag } from 'react-icons/fa';

interface ReportButtonProps {
  contentId: string;
  contentPreview: string;
  variant: 'A' | 'B';
  className?: string;
  onModalToggle?: (isOpen: boolean) => void;
}

export default function ReportButton({ 
  contentId, 
  contentPreview, 
  variant = 'A',
  className = '',
  onModalToggle
}: ReportButtonProps) {
  const navigate = useNavigate();

  const handleReport = () => {
    // Navigate to report page with content data
    navigate('/report', {
      state: {
        contentId,
        contentPreview,
        returnUrl: window.location.pathname
      }
    });
  };

  // Design A: Visible CTA button
  if (variant === 'A') {
    return (
      <button
        onClick={handleReport}
        className={`flex items-center space-x-2 text-xs text-gray-400 hover:text-red-400 transition-colors duration-200 mt-2 ${className}`}
      >
        <FaFlag className="w-3 h-3" />
        <span>🚩 Signaler ce passage</span>
      </button>
    );
  }

  // Design B: Simple flag button
  return (
    <button
      onClick={handleReport}
      className={`p-1 rounded-full hover:bg-gray-100 transition-colors duration-200 ${className}`}
      title="Signaler ce contenu"
    >
      <FaFlag className="w-3 h-3 text-gray-400 hover:text-red-500" />
    </button>
  );
}